<template>
    <div>
        <div class="flex">
            <p class="w-320 font-semibold my-4 first-letter:uppercase">{{ $t('general.start_date') }}</p>
            <p>{{ startDate(form.startDate) }}</p>
        </div>
        <div class="flex">
            <p class="w-320 font-semibold my-4 first-letter:uppercase">{{ $t('multi-posting.campaigns.details.publication_language') }}</p>
            <p>{{ publicationLanguage }}</p>
        </div>
        <div class="flex">
            <p class="w-320 font-semibold my-4 first-letter:uppercase">{{ $t('general.country') }}</p>
            <p>{{ country }}</p>
        </div>
        <div class="flex">
            <p class="w-320 font-semibold my-4 first-letter:uppercase">{{ $t('multi-posting.campaigns.form.vacancy.title') }}</p>
            <p>{{ title }}</p>
        </div>
        <div class="flex">
            <p class="w-320 mr-16 font-semibold my-4">{{ $t('general.description') }}</p>
            <div class="flex items-end">
                <p class="overflow-hidden h-40">
                    <span class="text-ellipsis" v-html="form.description"></span>
                </p>
                <span v-if="form.description">...</span>
            </div>
        </div>
    </div>
</template>
<script>
import {mapState} from "pinia";
import moment from "moment/moment";
import _ from "lodash";
import {getCountriesSelectOptions} from "../../../../shared/helpers";
import {useMainStore} from "../../../state/store";
import {useMultiPostingStore} from "../../../state/modules/multiPosting";

export default {
    name: "PostingDetails",
    computed: {
        ...mapState(useMainStore, ['locale', 'currentCompany']),
        ...mapState(useMultiPostingStore, ['form', 'lookups']),
        publicationLanguages() {
            return this.currentCompany
                .jobsite.active_languages
                .map(lang => ({
                    value: lang,
                    label: _.capitalize(this.$t('languages.' + lang + '.adjective').toString())
                }));
        },
        publicationLanguage() {
            return this.publicationLanguages.find(x => x.value === this.form.publicationLanguage)?.label;
        },
        getCountriesSelect() {
            return getCountriesSelectOptions(this.$i18n);
        },
        country() {
            if (this.form.region) {
                return this.getCountriesSelect.find(x => x.value === this.form.region)?.label;
            }
            return null;
        },
        title() {
            return this.form.title;
        },
    },
    methods: {
        startDate(date) {
            if (!date) return;
            return moment(date).locale(this.locale).format('L').replaceAll('-', '/');
        },
    }
}
</script>
<style scoped>

</style>